import { useIntl } from 'react-intl'
import React, { useMemo } from 'react'
import { Close, Spinner } from 'app/assets/icons'
import { colors } from 'shared/assets/styles'
import {
    RoomClosedIcon,
    TableOrderIcon,
    TerraceClosedIcon
} from 'app-v2/assets/icons'
import { BodyText, H7, Spacer } from 'app-v2/design-systems'
import { COLOR, SIZE } from 'app-v2/design-tokens'
import { formatTableToDisplay } from 'shared/utils-v2'

export type TableStatusType =
    | 'SUCCESS'
    | 'UNAVAILABLE'
    | 'CLOSED'
    | 'OUTDOOR_CLOSED'
    | 'INDOOR_CLOSED'
    | 'LOADING'
    | 'IMMINENT_OPENING'

type Props = {
    tableNumber: string,
    status: TableStatusType
}
export const TableStatus = (props: Props) => {
    const intl = useIntl()

    const [intlKey, Icon, color, size = 168] = useMemo(() => {
        switch (props.status) {
            case 'IMMINENT_OPENING':
                return [
                    'ecommerce.kingtable.welcome.description.imminentOpening.restaurant',
                    Close,
                    colors.fieryRed
                ]
            case 'UNAVAILABLE':
                return [
                    'ecommerce.kingtable.welcome.description.unavailable',
                    Close,
                    colors.fieryRed
                ]
            case 'CLOSED':
                return [
                    'ecommerce.kingtable.welcome.description.closed.restaurant',
                    Close,
                    colors.fieryRed
                ]
            case 'OUTDOOR_CLOSED':
                return [
                    'ecommerce.kingtable.welcome.description.closed.outdoor',
                    TerraceClosedIcon
                ]
            case 'INDOOR_CLOSED':
                return [
                    'ecommerce.kingtable.welcome.description.closed.indoor',
                    RoomClosedIcon
                ]
            case 'SUCCESS':
                return [
                    'ecommerce.kingtable.welcome.description',
                    TableOrderIcon
                ]
            case 'LOADING':
                return [
                    'ecommerce.kingtable.welcome.description',
                    Spinner,
                    COLOR.PRIMARY,
                    120
                ]
        }
    }, [props.status])

    return (
        <>
            <BodyText center>
                {intl.formatMessage({
                    id: intlKey
                })}
            </BodyText>
            <Icon color={color} size={size} />
            <H7 center>
                {intl.formatMessage(
                    {
                        id: 'ecommerce.kingtable.table'
                    },
                    { number: formatTableToDisplay(props.tableNumber) }
                )}
            </H7>
        </>
    )
}
